import { createContext, useContext } from 'react';

import type { PropertyDetailMode } from '../types/property-detail.types';

interface PropertyDetailModeContextValue {
  mode: PropertyDetailMode;
  isSyncManaged: boolean;
}

export const PropertyDetailModeContext =
  createContext<PropertyDetailModeContextValue | null>(null);

/**
 * DetailField + sub-component renderers consume mode/sync state via this
 * hook so the page doesn't have to prop-drill through every field group.
 * Throws if used outside the page's provider — a programming error.
 */
export function usePropertyDetailMode(): PropertyDetailModeContextValue {
  const ctx = useContext(PropertyDetailModeContext);
  if (!ctx) {
    throw new Error(
      'usePropertyDetailMode must be used within PropertyDetailModeContext.Provider',
    );
  }
  return ctx;
}
